/**
 * <s-card-reveal> fades product cards up as they enter the viewport (works on
 * iPhone too, unlike scroll-driven CSS). Wraps a `[data-reveal-list]` list and
 * watches its direct <li> children, including ones added later by filters or
 * pagination. Does nothing when the buyer prefers reduced motion.
 */
class SCardReveal extends HTMLElement {
  #io;
  #mo;

  connectedCallback() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (!('IntersectionObserver' in window)) return;

    this.#io = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (!entry.isIntersecting) continue;
          entry.target.classList.add('is-visible');
          this.#io.unobserve(entry.target);
        }
      },
      { rootMargin: '0px 0px -6% 0px', threshold: 0.05 }
    );

    this.classList.add('reveal-ready');
    this.#observeItems();

    this.#mo = new MutationObserver(() => this.#observeItems());
    this.#mo.observe(this, { childList: true, subtree: true });
  }

  disconnectedCallback() {
    this.#io?.disconnect();
    this.#mo?.disconnect();
  }

  #observeItems() {
    const items = this.querySelectorAll('[data-reveal-list] > li:not([data-reveal-watched])');
    let index = 0;
    for (const item of items) {
      item.setAttribute('data-reveal-watched', '');
      item.style.setProperty('--reveal-delay', `${(index % 5) * 60}ms`);
      this.#io.observe(item);
      index += 1;
    }
  }
}

if (!customElements.get('s-card-reveal')) {
  customElements.define('s-card-reveal', SCardReveal);
}
